<template>
  <b-tab>
    <template #title>
      <span class="d-none d-sm-inline">Display Phone Options</span>
    </template>
    <b-button
      variant="success"
      class="mb-2"
      @click="savePhoneOptions"
    >
      Save Display Phone Options
    </b-button>
    <validation-observer ref="formRef">
      <b-form>
        <b-row>
          <b-col md="4">
            <validation-provider
              name="From Time"
              rules="required|between:1,24"
            >
              <b-form-group
                slot-scope="{ errors }"
                label="From Time (Hour)"
                label-for="from-time"
              >
                <b-form-input
                  id="from-time"
                  v-model="formData.from_time"
                  type="number"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col md="4">
            <validation-provider
              name="To Time"
              rules="required|between:1,24"
            >
              <b-form-group
                slot-scope="{ errors }"
                label="To Time (Hour)"
                label-for="to-time"
              >
                <b-form-input
                  id="to-time"
                  v-model="formData.to_time"
                  type="number"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col md="4">
            <b-form-group
              label="Active"
              label-for="active"
            >
              <b-form-checkbox
                id="active"
                v-model="formData.active"
                switch
              />
            </b-form-group>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
  </b-tab>
</template>

<script>
import {
  BTab, BForm, BButton, BFormInput, BRow, BCol, BFormCheckbox, BFormGroup,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { reactive, ref } from '@vue/composition-api'
import { successNotification } from '@/utils/toast-notifications'

export default {
  components: {
    BTab, BForm, BButton, ValidationProvider, ValidationObserver, BFormInput, BRow, BCol, BFormCheckbox, BFormGroup,
  },
  props: {
    phoneOptions: {
      type: Object,
      default: undefined,
    },
  },
  setup(props, { emit }) {
    const formData = reactive({
      from_time: null,
      to_time: null,
      active: false,

    })
    if (props.phoneOptions) {
      Object.keys(props.phoneOptions).forEach(k => {
        formData[k] = props.phoneOptions[k]
      })
    }
    const formRef = ref(null)
    const savePhoneOptions = async () => {
      const valid = await formRef.value.validate()
      if (!valid) return
      emit('display-phone-options-set', formData)
      successNotification('Saved..')
    }
    return {
      formRef,
      formData,
      savePhoneOptions,
    }
  },
}
</script>

<style>

</style>
